"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _globalize = _interopRequireDefault(require("@sprinx/globalize"));

var _dateFormatter2 = _interopRequireDefault(require("@sprinx/formatting/dateFormatter"));

var _addDays2 = _interopRequireDefault(require("date-fns/addDays"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addYears = _interopRequireDefault(require("date-fns/addYears"));

var _differenceInMilliseconds = _interopRequireDefault(require("date-fns/differenceInMilliseconds"));

var _eachDayOfInterval = _interopRequireDefault(require("date-fns/eachDayOfInterval"));

var _endOfDay2 = _interopRequireDefault(require("date-fns/endOfDay"));

var _endOfWeek = _interopRequireDefault(require("date-fns/endOfWeek"));

var _endOfYear = _interopRequireDefault(require("date-fns/endOfYear"));

var _getHours2 = _interopRequireDefault(require("date-fns/getHours"));

var _getMinutes2 = _interopRequireDefault(require("date-fns/getMinutes"));

var _getSeconds2 = _interopRequireDefault(require("date-fns/getSeconds"));

var _getYear2 = _interopRequireDefault(require("date-fns/getYear"));

var _isAfter2 = _interopRequireDefault(require("date-fns/isAfter"));

var _isBefore2 = _interopRequireDefault(require("date-fns/isBefore"));

var _isEqual2 = _interopRequireDefault(require("date-fns/isEqual"));

var _isSameDay2 = _interopRequireDefault(require("date-fns/isSameDay"));

var _isValid2 = _interopRequireDefault(require("date-fns/isValid"));

var _setHours2 = _interopRequireDefault(require("date-fns/setHours"));

var _setMinutes2 = _interopRequireDefault(require("date-fns/setMinutes"));

var _setMonth2 = _interopRequireDefault(require("date-fns/setMonth"));

var _setSeconds2 = _interopRequireDefault(require("date-fns/setSeconds"));

var _setYear2 = _interopRequireDefault(require("date-fns/setYear"));

var _startOfDay2 = _interopRequireDefault(require("date-fns/startOfDay"));

var _startOfMonth2 = _interopRequireDefault(require("date-fns/startOfMonth"));

var _endOfMonth2 = _interopRequireDefault(require("date-fns/endOfMonth"));

var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));

var _startOfYear = _interopRequireDefault(require("date-fns/startOfYear"));

/* eslint-disable class-methods-use-this */
var DateFnsUtils =
/*#__PURE__*/
function () {
  function DateFnsUtils() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        locale = _ref.locale;

    (0, _classCallCheck2.default)(this, DateFnsUtils);
    this.locale = void 0;
    this.yearFormat = 'yyyy';
    this.yearMonthFormat = 'yyyyMM';
    this.dateTime12hFormat = 'yyyyMMddjjmm';
    this.dateTime24hFormat = 'yyyyMMddHHmm';
    this.time12hFormat = 'jjmm';
    this.time24hFormat = 'HHmm';
    this.dateFormat = 'yyyyMMdd';
    this.locale = locale || _globalize.default.locale();
  } // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
  // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.


  (0, _createClass2.default)(DateFnsUtils, [{
    key: "addDays",
    value: function addDays(value, count) {
      return (0, _addDays2.default)(value, count);
    }
  }, {
    key: "isValid",
    value: function isValid(value) {
      return (0, _isValid2.default)(this.date(value));
    }
  }, {
    key: "getDiff",
    value: function getDiff(value, comparing) {
      return (0, _differenceInMilliseconds.default)(value, this.date(comparing));
    }
  }, {
    key: "isAfter",
    value: function isAfter(value, comparing) {
      return (0, _isAfter2.default)(value, comparing);
    }
  }, {
    key: "isBefore",
    value: function isBefore(value, comparing) {
      return (0, _isBefore2.default)(value, comparing);
    }
  }, {
    key: "startOfDay",
    value: function startOfDay(value) {
      return (0, _startOfDay2.default)(value);
    }
  }, {
    key: "endOfDay",
    value: function endOfDay(value) {
      return (0, _endOfDay2.default)(value);
    }
  }, {
    key: "getHours",
    value: function getHours(value) {
      return (0, _getHours2.default)(value);
    }
  }, {
    key: "setHours",
    value: function setHours(value, count) {
      return (0, _setHours2.default)(value, count);
    }
  }, {
    key: "getMinutes",
    value: function getMinutes(value) {
      return (0, _getMinutes2.default)(value);
    }
  }, {
    key: "setMinutes",
    value: function setMinutes(value, count) {
      return (0, _setMinutes2.default)(value, count);
    }
  }, {
    key: "getSeconds",
    value: function getSeconds(value) {
      return (0, _getSeconds2.default)(value);
    }
  }, {
    key: "setSeconds",
    value: function setSeconds(value, count) {
      return (0, _setSeconds2.default)(value, count);
    }
  }, {
    key: "isSameDay",
    value: function isSameDay(value, comparing) {
      return (0, _isSameDay2.default)(value, comparing);
    }
  }, {
    key: "startOfMonth",
    value: function startOfMonth(value) {
      return (0, _startOfMonth2.default)(value);
    }
  }, {
    key: "endOfMonth",
    value: function endOfMonth(value) {
      return (0, _endOfMonth2.default)(value);
    }
  }, {
    key: "getYear",
    value: function getYear(value) {
      return (0, _getYear2.default)(value);
    }
  }, {
    key: "setYear",
    value: function setYear(value, count) {
      return (0, _setYear2.default)(value, count);
    }
  }, {
    key: "date",
    value: function date(value) {
      if (typeof value === 'undefined') {
        return new Date();
      }

      if (value === null) {
        return null;
      }

      return new Date(value);
    }
  }, {
    key: "parse",
    value: function parse(value, formatString) {
      if (value === '') {
        return null;
      }

      var parser = _globalize.default.dateParser({
        skeleton: formatString
      });

      return parser(value) || new Date();
    }
  }, {
    key: "format",
    value: function format(date, formatString) {
      var raw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return (0, _dateFormatter2.default)(date, (0, _defineProperty2.default)({}, raw ? 'raw' : 'skeleton', formatString));
    }
  }, {
    key: "isEqual",
    value: function isEqual(date, comparing) {
      if (date === null && comparing === null) {
        return true;
      }

      return (0, _isEqual2.default)(date, comparing);
    }
  }, {
    key: "isNull",
    value: function isNull(date) {
      return date === null;
    }
  }, {
    key: "isAfterDay",
    value: function isAfterDay(date, value) {
      return (0, _isAfter2.default)(date, (0, _endOfDay2.default)(value));
    }
  }, {
    key: "isBeforeDay",
    value: function isBeforeDay(date, value) {
      return (0, _isBefore2.default)(date, (0, _startOfDay2.default)(value));
    }
  }, {
    key: "isBeforeYear",
    value: function isBeforeYear(date, value) {
      return (0, _isBefore2.default)(date, (0, _startOfYear.default)(value));
    }
  }, {
    key: "isAfterYear",
    value: function isAfterYear(date, value) {
      return (0, _isAfter2.default)(date, (0, _endOfYear.default)(value));
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(numberToFormat) {
      return numberToFormat.toString();
    }
  }, {
    key: "getMonth",
    value: function getMonth(date) {
      return date.getMonth();
    }
  }, {
    key: "setMonth",
    value: function setMonth(date, count) {
      return (0, _setMonth2.default)(date, count);
    }
  }, {
    key: "getMeridiemText",
    value: function getMeridiemText(ampm) {
      return ampm === 'am' ? 'AM' : 'PM';
    }
  }, {
    key: "getNextMonth",
    value: function getNextMonth(date) {
      return (0, _addMonths.default)(date, 1);
    }
  }, {
    key: "getPreviousMonth",
    value: function getPreviousMonth(date) {
      return (0, _addMonths.default)(date, -1);
    }
  }, {
    key: "getMonthArray",
    value: function getMonthArray(date) {
      var firstMonth = (0, _startOfYear.default)(date);
      var monthArray = [firstMonth];

      while (monthArray.length < 12) {
        var prevMonth = monthArray[monthArray.length - 1];
        monthArray.push(this.getNextMonth(prevMonth));
      }

      return monthArray;
    }
  }, {
    key: "mergeDateAndTime",
    value: function mergeDateAndTime(date, time) {
      return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    }
  }, {
    key: "getWeekdays",
    value: function getWeekdays() {
      var _this = this;

      var now = new Date();
      return (0, _eachDayOfInterval.default)({
        start: (0, _startOfWeek.default)(now, {
          locale: this.locale
        }),
        end: (0, _endOfWeek.default)(now, {
          locale: this.locale
        })
      }).map(function (day) {
        return _this.format(day, 'E');
      });
    }
  }, {
    key: "getWeekArray",
    value: function getWeekArray(date) {
      var start = (0, _startOfWeek.default)((0, _startOfMonth2.default)(date), {
        locale: this.locale
      });
      var end = (0, _endOfWeek.default)((0, _endOfMonth2.default)(date), {
        locale: this.locale
      });
      var count = 0;
      var current = start;
      var nestedWeeks = [];

      while ((0, _isBefore2.default)(current, end)) {
        var weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        nestedWeeks[weekNumber].push(current);
        current = (0, _addDays2.default)(current, 1);
        count += 1;
      }

      return nestedWeeks;
    }
  }, {
    key: "getYearRange",
    value: function getYearRange(start, end) {
      var startDate = (0, _startOfYear.default)(start);
      var endDate = (0, _endOfYear.default)(end);
      var years = [];
      var current = startDate;

      while ((0, _isBefore2.default)(current, endDate)) {
        years.push(current);
        current = (0, _addYears.default)(current, 1);
      }

      return years;
    } // displaying methpds

  }, {
    key: "getCalendarHeaderText",
    value: function getCalendarHeaderText(date) {
      return this.format(date, 'yyyyMMM');
    }
  }, {
    key: "getYearText",
    value: function getYearText(date) {
      return this.format(date, 'yyyy');
    }
  }, {
    key: "getDatePickerHeaderText",
    value: function getDatePickerHeaderText(date) {
      return this.format(date, 'MMMEd');
    }
  }, {
    key: "getDateTimePickerHeaderText",
    value: function getDateTimePickerHeaderText(date) {
      return this.format(date, 'MMMd');
    }
  }, {
    key: "getMonthText",
    value: function getMonthText(date) {
      return this.format(date, 'MMMM');
    }
  }, {
    key: "getDayText",
    value: function getDayText(date) {
      return this.format(date, 'd');
    }
  }, {
    key: "getHourText",
    value: function getHourText(date) {
      return this.format(date, 'HH');
    }
  }, {
    key: "getMinuteText",
    value: function getMinuteText(date) {
      return this.format(date, 'mm', true);
    }
  }, {
    key: "getSecondText",
    value: function getSecondText(date) {
      return this.format(date, 'ss', true);
    }
  }, {
    key: "getFirstDayOfWeek",
    value: function getFirstDayOfWeek() {
      return _globalize.default.cldr.supplemental.weekData.firstDay();
    }
  }]);
  return DateFnsUtils;
}();

exports.default = DateFnsUtils;